<template>
  <div class="p-article m-amp-article__wrapper container">
    <!-- Google Tag Manager -->
    <amp-analytics v-if="$config.mode === 'production'" config="https://www.googletagmanager.com/amp.json?id=GTM-TBNBKWP&gtm.url=SOURCE_URL" data-credentials="include" />
    <!-- 內文頁主體 -->
    <div class="p-article__body">
      <div class="e-category">
        <div class="e-category__main">
          {{ ampData.article.main_category }}
        </div>
        <div class="e-category__child">
          {{ ampData.article.sub_category }}
        </div>
      </div>
      <h1 class="p-article__title">
        {{ ampData.article.title }}
      </h1>
      <p class="p-article-info">
        <span v-if="ampData.article.participants.reporter !== '' && ampData.article.participants.reporter !== undefined " class="m-amp-article__participants">
          {{ `記者：${ampData.article.participants.reporter}` }}
        </span>
        <span v-if="ampData.article.participants.editor !== '' && ampData.article.participants.editor !== undefined " class="m-amp-article__participants">
          {{ `編輯：${ampData.article.participants.editor}` }}
        </span>
        <span v-if="ampData.article.participants.author !== '' && ampData.article.participants.author !== undefined " class="m-amp-article__participants">
          {{ `作者：${ampData.article.participants.author}` }}
        </span>
        {{ ` ｜ ${publishTime}` }}
      </p>
      <amp-social-share
        :data-param-url="`${HOST}/article/${ampData.article.article_id}`"
        type="line"
        width="35"
        height="35"
        class="m-amp-sharebar__icon"
      />
      <amp-social-share
        :data-param-href="`${HOST}/article/${ampData.article.article_id}`"
        type="facebook"
        width="35"
        height="35"
        data-param-app_id="661963624562695"
        class="m-amp-sharebar__icon"
      />
      <amp-social-share :data-param-url="`${HOST}/article/${ampData.article.article_id}`" type="whatsapp" width="35" height="35" class="m-amp-sharebar__icon" />
      <div class="p-article__content">
        <div class="p-article__img-box">
          <amp-img
            :src="ampData.article.cover.md"
            :alt="ampData.article.caption"
            class="p-article__img"
            layout="responsive"
            width="375"
            height="197"
          >
            <amp-img
              :alt="ampData.article.caption"
              fallback
              src="https://static.ctwant.com/images/dist/default_cover_md.png"
              class="p-article__img"
              layout="responsive"
              width="375"
              height="197"
            />
          </amp-img>
          <p class="p-article__cover-graph">
            {{ ampData.article.caption }}
          </p>
        </div>
        <div class="m-amp-article" v-html="ampData.article.amp_content" />
      </div>
      <!-- 引文 -->
      <p v-if="ampData.article.remark !== ''" class="m-remark" v-html="ReplaceNewline(ampData.article.remark)" />
      <!-- 引文 -->
      <!-- 系列文章 -->
      <SeriesArticles
        :article-type="'article'"
        :series-data="ampData.article.series"
        :topic-data="ampData.article.topic"
        :is-amp="true"
      />
      <!-- 系列文章 -->
      <!-- 同類別額外五則 -->
      <!--
      <CategoryExtra
        :main-category="main_category"
        :sub-category="ampData.article.sub_category"
        :category-extra-data="ampData.category_extra"
        :is-amp="true"
      />
      -->
      <!-- 同類別額外五則 -->
      <!-- 延伸閱讀 -->
      <div v-if="ampData.article.extended !== null && ampData.article.extended.length > 0" class="l-section">
        <h2 class="l-section__title">
          延伸閱讀
        </h2>
        <ul id="article-extended" class="e-list">
          <li v-for="article in ampData.article.extended" :key="article.url">
            <a :href="`https://www.ctwant.com${article.url}/`" class="e-list__link" title="前往 CTWANT 新聞頁">
              {{ article.title }}
            </a>
          </li>
        </ul>
      </div>
      <div class="l-section">
        <div class="l-ad__wrapper">
          <amp-ad
            :json="targeting"
            width="320"
            height="100"
            type="doubleclick"
            data-slot="/21830015939/ctwant_amp_article_bottom"
          />
        </div>
      </div>
      <!-- 人氣新聞 -->
      <div class="l-section">
        <h2 class="l-section__title-with-hr">
          人氣新聞
          <amp-img
            src="https://static.ctwant.com/images/dist/fire.svg"
            width="16"
            height="16"
            class="m-amp-section__hot"
            layout="responsive"
            alt="人氣新聞圖示"
          />
        </h2>
        <hr>
        <a
          v-for="(i, index) in ampData.popular.slice(0, 6)"
          :key="i.article_id"
          :href="`https://www.ctwant.com/article/${i.article_id}/`"
          class="m-amp-card__container"
          title="前往 CTWANT 新聞頁"
        >
          <amp-img
            :src="i.cover.sm"
            :alt="i.caption"
            width="136"
            height="71"
            class="m-amp-card__img"
            layout="responsive"
          />
          <div class="m-amp-card__content">
            <h3 class="m-amp-card__title m-amp--mle-2">
              {{ i.title }}
            </h3>
            <time :datetime="i.publish_at" class="e-time">
              <amp-img
                src="https://static.ctwant.com/images/dist/clock.svg"
                width="14"
                height="14"
                class="m-amp-card__clock"
                layout="responsive"
                alt="發佈時間標示圖"
              />
              {{ i.publish_at }}
              <amp-img
                v-if="index <= 2"
                src="https://static.ctwant.com/images/dist/fire.svg"
                width="16"
                height="21"
                class="m-amp-card__hot"
                layout="responsive"
                alt="人氣新聞標示圖"
              />
            </time>
          </div>
        </a>
      </div>
      <div class="l-section">
        <div class="m-amp-ad">
          <amp-ad
            type="popin"
            width="300"
            height="568"
            layout="responsive"
            heights="(min-width:1907px) 39%, (min-width:1200px) 46%, (min-width:780px) 64%, (min-width:480px) 98%, (min-width:460px) 167%, 196%"
            data-mediaid="ctwant_amp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import articleHelpers from '@/utils/articleHelpers.js'
import SeriesArticles from '@/components/SeriesArticles.vue'
// import CategoryExtra from '@/components/CategoryExtra.vue'
export default {
  amp: 'only',
  ampLayout: 'default.amp',
  components: {
    SeriesArticles
    // CategoryExtra
  },
  mixins: [articleHelpers],
  validate({ params, redirect }) {
    if (/^\d+$/.test(params.id) === false) {
      redirect(301, '/')
    }
    return /^\d+$/.test(params.id)
  },
  async asyncData({ $axios, route, params, query, redirect, error, store }) {
    const api = $axios.defaults.baseURL
    const url = `${api}/amp/article/${params.id}`
    try {
      if (route.path.substr(-1) !== '/' && Object.keys(query).length <= 0) {
        redirect(301, `${route.path}/`)
      }

      const { data } = await $axios.$get(url)
      store.commit('ad/SET_IS_OTHER_AD', data.article.is_other_ad)
      store.commit('ad/SET_IS_HIDE_AD', data.article.is_hide_ad)
      return { ampData: data, main_category: data.article.main_category }
    } catch (e) {
      console.error('AmpArticle', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      ampData: null,
      newsData: null,
      main_category: null
    }
  },
  head() {
    const articleData = {
      title: `${this.ampData.article.title} | ${this.main_category} | CTWANT`,
      url: this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path.substr(0, this.$route.path.length - 1) : this.$route.path),
      sourceUrl: `${this.HOST}/article/${this.ampData.article.article_id}/`,
      thumbnailUrl: (this.ampData.article.has_large_cover === 'Y') ? this.ampData.article.cover.lg : this.ampData.article.cover.md,
      coverIsLg: (this.ampData.article.has_large_cover === 'Y'),
      caption: this.ampData.article.caption,
      main_category: this.main_category,
      keywords: this.ampData.article.tags.join(),
      articleSection: this.main_category,
      description: this.ampData.article.pure_content.replace(/<[^>]+>|&[^>]+;/g, '').trim().substr(0, 100),
      author: this.ampData.article.participants.reporter || this.ampData.article.participants.editor || this.ampData.article.participants.author || 'CTWANT',
      publishTime: this.ampData.article.publish_at_time_zone,
      updateTime: this.ampData.article.updated_at_time_zone
    }
    let ImageObject = {
      '@context': 'http://schema.org',
      '@type': 'ImageObject',
      contentUrl: articleData.thumbnailUrl,
      caption: articleData.caption,
      height: (articleData.coverIsLg) ? '632' : '452',
      width: (articleData.coverIsLg) ? '1200' : '858'
    }
    const NewsArticle = {
      '@context': 'http://schema.org',
      '@type': 'NewsArticle',
      headline: articleData.title,
      url: articleData.url,
      thumbnailUrl: articleData.thumbnailUrl,
      articleSection: articleData.articleSection,
      keywords: articleData.keywords,
      description: articleData.description,
      ImageObject,
      author: {
        '@type': 'Person',
        name: articleData.author
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': articleData.sourceUrl
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        url: this.HOST,
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/ctwant_logo_600x60.png',
          height: '60',
          width: '600'
        }
      },
      dateCreated: articleData.publishTime,
      datePublished: articleData.publishTime,
      dateModified: articleData.updateTime
    }
    const Article = { ...NewsArticle }
    Article['@type'] = 'Article'

    if (this.ampData.article.content_images.length > 0) {
      const cover = { ...ImageObject }
      ImageObject = [cover]
      this.ampData.article.content_images.forEach((contentImageItem) => {
        ImageObject.push({
          '@context': 'http://schema.org',
          '@type': 'ImageObject',
          contentUrl: contentImageItem.url,
          caption: contentImageItem.figcaption,
          height: contentImageItem.height,
          width: contentImageItem.width
        })
      })
    }

    const BreadcrumbList = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': this.HOST,
            name: 'CTWANT'
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': `${this.HOST}/category/${articleData.main_category}`,
            name: articleData.main_category
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@id': articleData.url,
            name: articleData.title
          }
        }
      ]
    }
    let BreadcrumbListIncludeTopic = null
    if (Object.keys(this.ampData.article.topic).length > 0) {
      BreadcrumbListIncludeTopic = JSON.parse(JSON.stringify(BreadcrumbList))
      BreadcrumbListIncludeTopic.itemListElement.splice(2, 0, {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@id': `${this.HOST}/topic/${this.ampData.article.topic.topic_id}/`,
          name: this.ampData.article.topic.title
        }
      })
      BreadcrumbListIncludeTopic.itemListElement[3].position = 4
    }
    const SeriesListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.ampData.article.series.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover ? item.cover.md : '',
          url: `https://www.ctwant.com/article/${item.id}/`
        }
      })
    }
    const HotNewsListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.ampData.popular.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover.md,
          url: `https://www.ctwant.com/article/${item.article_id}/`
        }
      }).slice(0, 5)
    }
    return {
      title: `${this.ampData.article.title} | ${this.main_category} | CTWANT`,
      meta: [
        { hid: 'description', name: 'description', content: articleData.description },
        { hid: 'keywords', name: 'keywords', content: articleData.keywords },
        { hid: 'author', name: 'author', content: 'CTWANT' },
        { hid: 'ogUrl', property: 'og:url', content: articleData.sourceUrl },
        { hid: 'ogType', property: 'og:type', content: 'website' },
        { hid: 'ogTitle', property: 'og:title', content: articleData.title },
        { hid: 'ogDescription', property: 'og:description', content: articleData.description },
        { hid: 'max-image-preview', name: 'robots', content: (articleData.coverIsLg) ? 'max-image-preview:large' : 'max-image-preview:standard' },
        { hid: 'ogImage', property: 'og:image', content: articleData.thumbnailUrl },
        { hid: 'articlePublished_time', name: 'pubdate', property: 'article:published_time', itemprop: 'datePublished', content: articleData.publishTime },
        { hid: 'articleModified_time', name: 'lastmod', property: 'article:modified_time', itemprop: 'dateModified', content: articleData.updateTime },
        { hid: 'articleSection', property: 'article:section', itemprop: 'articleSection', content: articleData.main_category }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: articleData.sourceUrl },
        { hid: 'canonical', rel: 'canonical', href: articleData.sourceUrl },
        { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Noto+Sans+TC&display=swap' }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(NewsArticle), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(Article), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(ImageObject), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(BreadcrumbList), type: 'application/ld+json' },
        ...(BreadcrumbListIncludeTopic ? [{ innerHTML: JSON.stringify(BreadcrumbListIncludeTopic), type: 'application/ld+json' }] : []),
        { innerHTML: JSON.stringify(SeriesListItem.itemListElement.length > 0 ? SeriesListItem : HotNewsListItem), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST'
    ]),
    targeting() {
      if (this.ampData.article.is_other_ad === 'Y') {
        return '{"targeting":{"adult":"Y"}}'
      } else {
        return ''
      }
    },
    publishTime() {
      return this.ampData.article.publish_at.replace(/ /g, '　')
    }
  }
}
</script>

<style lang="scss" scoped>
// element
@import '~/assets/scss/element/_category';
@import '~/assets/scss/element/_list';
@import '~/assets/scss/element/_time';

// modules
@import '~/assets/scss/modules/_amp';
@import '~/assets/scss/modules/_remark';

// layout
@import '~/assets/scss/layout/_section';
@import '~/assets/scss/layout/_ad';

// pages
@import '~/assets/scss/pages/_article';
</style>

<style>
.m-amp-article__img{
  width: 100%;
}
.m-amp-ad__wrapper{
  margin-bottom: 15px;
  margin-top: 15px;
  text-align: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  background-color: #e2e2e2;
}
</style>
